.svg { width: 100%; height: 100%; display: block; }

.state {
  fill: #e6e8ec;
  stroke: #ffffff;
  stroke-width: 1;
  stroke-linejoin: round;
}

.city { cursor: pointer; }
.bubble { stroke: #fff; stroke-width: 1.5; transition: opacity 0.12s ease; }
.city:hover .bubble { opacity: 0.82; }

/* Figma legend bands. */
.high { fill: #34a853; }
.mid  { fill: #e8871a; }
.low  { fill: #e5484d; }
.none { fill: #b9bec7; }

.selected .bubble { stroke: #1c1e23; stroke-width: 2.5; }

.value {
  fill: #fff;
  font-weight: 700;
  text-anchor: middle;
  dominant-baseline: central;
  pointer-events: none;
}
.label {
  fill: #3d424d;
  font-size: 11px;
  font-weight: 500;
  pointer-events: none;
}
